/**
 * String Formatting Utilities
 *
 * Common text formatting functions used across the app.
 */

/**
 * Capitalize the first letter of a string
 * @example capitalize('admin') => 'Admin'
 */
export function capitalize(str: string): string {
  if (!str) return str;
  return str.charAt(0).toUpperCase() + str.slice(1);
}

/**
 * Capitalize and format a status/role string for display
 * Replaces underscores with spaces and capitalizes first letter
 * @example formatStatus('in_progress') => 'In progress'
 */
export function formatStatus(status: string): string {
  if (!status) return status;
  return status.charAt(0).toUpperCase() + status.slice(1).replace(/_/g, ' ');
}
